/* import __COLOCATED_TEMPLATE__ from './fly-conditional-tooltip.hbs.js'; */
import Component from '@glimmer/component';
export default class FlyConditionalTooltip extends Component {
  get direction() {
    return this.args.direction ?? 'bottom';
  }
  get contextual() {
    return this.args.contextual ?? false;
  }
  get truncate() {
    return this.args.truncate ?? false;
  }
}